export const HEAD_CELL_DETAILED = [
  {
    id: 'status',
    label: 'Вид',
  },
  {
    id: 'document_number',
    label: 'ID транзакции'
  },
  {
    id: 'transaction_status',
    label: 'Статус движения бонусов',
    sx: { whiteSpace: 'nowrap' },
  },
  {
    id: 'customerAccountId',
    label: 'Номер ЛС',
    sx: { whiteSpace: 'nowrap' },
  },
  {
    id: 'branchId',
    label: 'Идентификатор региона ЛС',
  },
  {
    id: 'reason_name',
    label: 'Причина начисления',
  },
  {
    id: 'created_at',
    label: 'Дата транзакции'
  },
  {
    id: 'campaign',
    label: 'Наименование кампании'
  },
  {
    id: 'amount',
    label: 'Кол-во бонусов'
  },
  {
    id: 'date_expiry',
    label: 'Срок действия бонусов',
    sx: { minWidth: 130 },
  }
];
